// extracted by mini-css-extract-plugin
module.exports = {"root":"HowDoesMadPawsWork_root__MQOFk","image":"HowDoesMadPawsWork_image__3z86D","content":"HowDoesMadPawsWork_content__5kcN_"};